'use es6';

import { getProductInventory } from 'pricing-pages-lib/api/ProductInventoryApi';
import { createRequestTypes, createRequestActions } from './RequestActions';
import makeFetchRequest from './makeFetchRequest';
export const FetchProductInventoryRequestTypes = createRequestTypes('PRODUCT_INVENTORY');
export const FetchProductInventoryActions = createRequestActions(FetchProductInventoryRequestTypes);
export const fetchProductInventoryData = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchProductInventoryActions,
    fetch: getProductInventory
  })(dispatch);
};